"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ContextMenu_1 = __importDefault(require("../ContextMenu/ContextMenu"));
const LabelText_1 = __importDefault(require("../LabelText/LabelText"));
const useUniqueId_1 = require("../useUniqueId");
const Select_styled_1 = require("./Select.styled");
const Select_util_1 = require("./Select.util");
exports.Select = (_a) => {
    var { options, label, maxOptions, value, naked, onChange, customInputSettings, placeholder, color, disabled, filterable, id, customOption, fullWidth, tabIndex = 0 } = _a, rest = __rest(_a, ["options", "label", "maxOptions", "value", "naked", "onChange", "customInputSettings", "placeholder", "color", "disabled", "filterable", "id", "customOption", "fullWidth", "tabIndex"]);
    const uniqueId = useUniqueId_1.useUniqueId(id);
    const [filter, setFilter] = React.useState("");
    const $container = React.useRef(null);
    const $input = React.useMemo(() => React.createRef(), []);
    React.useEffect(() => {
        if (customOption && value === customOption.value && $input.current) {
            $input.current.focus();
        }
    }, [value, customOption]);
    const appendCustomOption = React.useCallback((optionToAppend) => (options) => {
        // We can't have a multiselect _and_ a custom option.
        if (Array.isArray(value) && process.env.NODE_ENV !== "production") {
            console.trace("⚠️ Cannot show custom option with a multi-select Select component. Please either choose to have a single value, or remove the `customOption` property from your `Select` component.");
            return options;
        }
        return Select_util_1.appendItem(Select_util_1.optionsToContextMenuItems()([optionToAppend])[0])(options);
    }, [customOption, value]);
    const filterComponent = React.useMemo(() => (React.createElement(Select_styled_1.FilterInput, { autoFocus: true, onClick: e => e.stopPropagation(), fullWidth: true, placeholder: "Filter...", value: filter, onChange: setFilter })), [filter]);
    /** Get a list of items to feed to the ContextMenu */
    const items = React.useMemo(() => {
        const initialOptions = options;
        const filteredOptions = Select_util_1.filterList(filter)(initialOptions);
        const truncatedOptions = Select_util_1.truncateList(maxOptions)(filteredOptions);
        const contextMenuItems = Select_util_1.optionsToContextMenuItems(option => ({
            label: option.label ? option.label : String(option.value),
            isActive: Select_util_1.isOptionSelected(value)(option),
        }))(truncatedOptions);
        // Case 1: It's both filterable _and_ has a custom option
        if (filterable && customOption !== undefined) {
            return appendCustomOption(customOption)(Select_util_1.prependItem({ label: filterComponent, separator: "bottom" })(contextMenuItems));
        }
        // Case 2: It's filterable and no custom option
        if (filterable && customOption === undefined) {
            return Select_util_1.prependItem({ label: filterComponent, separator: "bottom" })(contextMenuItems);
        }
        // Case 3, It has a custom option but is not filterable
        if (!filterable && customOption !== undefined) {
            return appendCustomOption(customOption)(contextMenuItems);
        }
        // Default case, it's just a normal set of items
        return contextMenuItems;
    }, [options, value, filter, maxOptions, filterable, customOption, onChange]);
    const isReadOnly = React.useMemo(() => (customOption ? customOption.value !== value : true), [customOption, value]);
    return (React.createElement(ContextMenu_1.default, Object.assign({ onClick: item => {
            if (onChange) {
                onChange(Select_util_1.getNewValue(value)(item.value), Select_util_1.getOptionFromItem(items)(item));
            }
            if ($container.current) {
                $container.current.focus();
            }
            if ($input.current) {
                $input.current.focus();
            }
        }, anchored: true, disabled: disabled, keepOpenOnItemClick: Array.isArray(value), items: items, "aria-labelledby": `operational-ui__Select-Label-${uniqueId}`, initialFocusedItemIndex: options.findIndex(option => option.value === value) }, rest), isOpen => (React.createElement(Select_styled_1.Listbox, { fullWidth: Boolean(fullWidth), ref: $container, "aria-labelledby": `operational-ui__Select-Label-${uniqueId}`, "aria-disabled": Boolean(disabled), disabled: Boolean(disabled), "aria-expanded": isOpen, id: `operational-ui__Select-${uniqueId}`, color: color },
        label && React.createElement(LabelText_1.default, { id: `operational-ui__Select-Label-${uniqueId}` }, label),
        React.createElement(Select_styled_1.Combobox, { isOpen: isOpen, hasCustomOption: customOption ? customOption.value === value : false, naked: Boolean(naked) },
            React.createElement(Select_styled_1.SelectInput, { inputRef: $input, fullWidth: fullWidth, tabIndex: customOption && customOption.value === value ? 0 : -1, disabled: disabled, placeholder: placeholder, hasCustomOption: customOption ? customOption.value === value : false, readOnly: isReadOnly, value: Select_util_1.getDisplayValue(value)(options), id: `operational-ui__Select-Input-${uniqueId}`, onClick: e => {
                    if (customOption && value === customOption.value) {
                        e.stopPropagation();
                    }
                }, onChange: newValue => {
                    if (onChange) {
                        onChange(newValue, customOption);
                    }
                }, onBlur: () => {
                    if (!isReadOnly && customInputSettings && customInputSettings.onBlur) {
                        customInputSettings.onBlur(Select_util_1.getDisplayValue(value)(options));
                    }
                } }),
            React.createElement(Select_styled_1.DropdownButton, { naked: Boolean(naked), hasCustomOption: customOption ? customOption.value === value : false, isOpen: isOpen }))))));
};
exports.default = exports.Select;
//# sourceMappingURL=Select.js.map